module.exports = {
  ROOT_API: process.env.VUE_APP_ROOT_API,
  FRONTEND_URL: process.env.VUE_APP_FRONTEND_URL,
  ROUTER_BASE: process.env.VUE_APP_ROUTER_BASE,
  BASE_URL: process.env.VUE_APP_FRONTEND_URL + process.env.VUE_APP_ROUTER_BASE,
  PROJECT_NAME: "JOB-PORTAL",
  COOL_OFF_PERIOD: 3, // in months
};
